import { type WorkerRequirement } from "@src/appV2/redesign/Documents/api/types";

import { isPostBookingRequirementForShift } from "./isPostBookingRequirementForShift";
import { isRequirementApplicableToShift } from "./isRequirementApplicableToShift";
import { isRequirementInValidForShift } from "./isRequirementInValidForShift";

interface FilterBlockingRequirementsForShiftProps {
  workplace: {
    id: string;
    workplaceType?: string;
    msa?: string;
    state?: string;
    region?: string; // also known as county
  };
  qualifications: string[];
  workplaceRequirements?: WorkerRequirement[];
  expiryDate: string;
}

export function filterBlockingRequirementsForShift(props: FilterBlockingRequirementsForShiftProps) {
  const { workplace, qualifications, workplaceRequirements, expiryDate } = props;

  return workplaceRequirements?.filter((requirement) => {
    if (
      isPostBookingRequirementForShift({ requirement, workplaceId: workplace.id, qualifications })
    ) {
      return false;
    }

    if (!isRequirementApplicableToShift({ requirement, workplace, qualifications })) {
      return false;
    }

    return isRequirementInValidForShift({ requirement, expiryDate });
  });
}
